export default "__VITE_ASSET__DTnyNdKe__"